import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../contexts/auth';
import { BriefcaseIcon, TrashIcon, CheckIcon, ClockIcon } from '@heroicons/react/24/outline';
import { PlusIcon } from '@heroicons/react/20/solid';
import { getWorkingHoursCompound, addWeeklyWorkingHourSlot , patchUpdateWeeklyWorkingHourSlot} from '../services/api_working_hours';
import { validateBreak, validateBreaks, validateTimeSlots } from '../utils/timeslots';
import Toggle from './toggle';
import ComboboxAutocomplete from './combobox_autocomplete';
import Swal from 'sweetalert2';
import { formatTime } from '../utils/timeslots';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import SvgBreak from './svg_break';
import TabellaTurnoGiornaliero from './tabella_visualizza_turno giornaliero';


const AddNewWeekTimeSlot = ({ onCancelEdit, weekWorkingHour, onWeekWorkingHour, selectedDayNumber, weekWorkingHourObject, onDeleteWeekTimeSlot, selectedOuId }) => {
  const { token } = useContext(AuthContext);
  const daysOfWeek = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];
  const selectedDay = selectedDayNumber ? daysOfWeek[selectedDayNumber - 1] : '';
  const [workStartTime, setWorkStartTime] = useState('');
  const [workEndTime, setWorkEndTime] = useState('');
  const [error, setError] = useState('');
  const [pauseTimes, setPauseTimes] = useState([]);
  const [creatingPause, setCreatingPause] = useState(false);
  const [workTimeError, setWorkTimeError] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [workingHours, setWorkingHours] = useState([]);
  const [selectedWorkingHourId, setSelectedWorkingHourId] = useState(null);
  const handleCancelClick = () => {
      onCancelEdit();
  };

  const dayIdx = selectedDayNumber;
  const selectedWeekWorkingHourSlot = (weekWorkingHourObject.slots_by_weekday || []).find(slot => slot.week_day === dayIdx);
  const selectedWorkingHour =  workingHours.find(wh => wh.id === selectedWorkingHourId);
  
  
  const handleWorkStartTimeChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.slice(0, 4);

    let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");
  
    if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
      formattedTime = formattedTime.replace(":", "");
    }
  
    setWorkStartTime(formattedTime);

    if (workEndTime && formattedTime >= workEndTime) {
      setWorkTimeError("L'orario di inizio deve essere precedente all'orario di fine.");
      return;
    } else {
      setWorkTimeError('');
      setError('');
    }
  };

  const handleWorkEndTimeChange = (e) => {
    let inputValue = e.target.value;
  
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.slice(0, 4);
  
    let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");
  
    if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
      formattedTime = formattedTime.replace(":", "");
    }
  
    setWorkEndTime(formattedTime);
    
    if (workStartTime && formattedTime <= workStartTime) {
      setWorkTimeError("L'orario di fine deve essere successivo all'orario di inizio.");
      return;
    } else {
      setWorkTimeError('');
      setError(''); 
    }
  };

  const handleWorkTimeBlur = (field) => {
    let formattedTime = field === 'start' ? workStartTime : workEndTime;
  
    formattedTime = formattedTime.replace(/\D/g, '');
  
    while (formattedTime.length < 4) {
      formattedTime += '0';
    }
  
    formattedTime = formattedTime.slice(0, 4);
  
    const hours = formattedTime.slice(0, 2);
    const minutes = formattedTime.slice(2);
    formattedTime = `${hours}:${minutes}`;
  
    const isValidTime = /^([01]?[0-9]|2[0-4]):[0-5][0-9]$/.test(formattedTime);
  
    if (!isValidTime) {
      if (field === 'start') {
        setWorkStartTime('');
      } else {
        setWorkEndTime('');
      }
      return;
    }
  
    if (field === 'start') {
      setWorkStartTime(formattedTime);
    } else {
      setWorkEndTime(formattedTime);
    }
  };
  
  
  const handleAddPause = () => {
    if (!workStartTime || !workEndTime) {
      setWorkTimeError("Prima di aggiungere una pausa, inserisci l'orario di lavoro.");
      return;
    }
  
    if (!creatingPause && pauseTimes.every(pause => pause.confirmed)) {
      setCreatingPause(true);
      setPauseTimes([...pauseTimes, { start_at: '', end_at: '', confirmed: false }]);
      setWorkTimeError('');
    } else {
      setCreatingPause(false);
      setPauseTimes(pauseTimes.filter(pause => pause.confirmed));
    }
  };

  const handlePauseStartTimeChange = (index, e) => {
    const updatedPauseTimes = [...pauseTimes];
    let inputValue = e.target.value;
    
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.slice(0, 4);
    
    let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");
  
    if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
      formattedTime = formattedTime.replace(":", "");
    }
    
    updatedPauseTimes[index].start_at = formattedTime;
    setPauseTimes(updatedPauseTimes);
  };
  
  const handlePauseEndTimeChange = (index, e) => {
    const updatedPauseTimes = [...pauseTimes];
    let inputValue = e.target.value;
    
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.slice(0, 4);
    
    let formattedTime = inputValue.replace(/(\d{2})(\d{0,2})/, "$1:$2");
  
    if (inputValue.length <= 2 && e.target.value.length < formattedTime.length) {
      formattedTime = formattedTime.replace(":", "");
    }
    updatedPauseTimes[index].end_at = e.target.value;
    setPauseTimes(updatedPauseTimes);
  };

const handlePauseTimeBlur = (index, field) => {
  if (!field) {
    return;
  }

  const updatedPauseTimes = [...pauseTimes];
  let formattedTime = updatedPauseTimes[index][field];

  if (typeof formattedTime === 'string') {
    formattedTime = formattedTime.replace(/\D/g, '');

    while (formattedTime.length < 4) {
      formattedTime += '0';
    }

    formattedTime = formattedTime.slice(0, 4);

    const hours = formattedTime.slice(0, 2);
    const minutes = formattedTime.slice(2);
    formattedTime = `${hours}:${minutes}`;

    const isValidTime = /^([01]?[0-9]|2[0-4]):[0-5][0-9]$/.test(formattedTime);

    if (!isValidTime) {
      updatedPauseTimes[index][field] = '' ;
      setPauseTimes(updatedPauseTimes);
      return;
    }

    updatedPauseTimes[index][field] = formattedTime;
    setPauseTimes(updatedPauseTimes);
  }
};

  const handleConfirmPause = (index) => {
    const updatedPauseTimes = [...pauseTimes];
    const currentPause = updatedPauseTimes[index];
    setError('');
    try {
      validateBreak(workStartTime, workEndTime, currentPause, pauseTimes);
      currentPause.confirmed = true;
      setPauseTimes(updatedPauseTimes);
      setCreatingPause(false);
    }
    catch(error) {
      console.log(error)
      setError(error.message);
      return;
    }
  };

  const handleDeletePause = (index) => {
    const updatedPauseTimes = [...pauseTimes];
    updatedPauseTimes.splice(index, 1);
    setPauseTimes(updatedPauseTimes);
  };

  const handleConfirmClick = () => {
    if (!workStartTime || !workEndTime) {
      setError("Prima di confermare, inserisci l'orario di lavoro.");
      return;
    }
  
    if (workStartTime > workEndTime) {
      setError("L'orario di fine deve essere successivo all'orario di inizio.");
      return;
    }
  
    setError('');
    const timeSlotData = {
      workStartTime,
      workEndTime,
      breaks: pauseTimes,
    };
  
  };

  const handleSaveTimeSlot = async () => {
    setError('');
    if (workTimeError || error) {
      return;
    }

    if (!selectedDay) {
      setError('Seleziona un giorno valido.');
      return;
    }
    
    try {
      const breaks = pauseTimes.map(breakItem => ({
        id: breakItem.id,
        start_at: breakItem.start_at,
        end_at: breakItem.end_at
      }));
  
      const weekWorkingHourId = weekWorkingHour;
      const newStartTime = workStartTime ? formatTime(workStartTime) : '';
      const newEndTime = workEndTime ? formatTime(workEndTime) : '';
      const selectedDayValue = selectedDayNumber;
      
      if (!selectedWorkingHourId) {
        try {
          validateBreaks(newStartTime, newEndTime, pauseTimes);
        } catch(error) {
          setError(error.message);
          return;
        }
  
        const selectedDayValue = selectedDayNumber;
        const dayObject = weekWorkingHourObject?.slots_by_weekday?.find(day => day.week_day === selectedDayValue);
        const dayTimeSlots = dayObject ? dayObject.time_slots : [];

        try {
          validateTimeSlots(newStartTime, newEndTime, dayTimeSlots);
        } catch (error) {
          setError(error.message);
          return;
        }
      }

      const dayExists = !!selectedWeekWorkingHourSlot ? true : false;

      const updatedTimeSlots = [...weekWorkingHour.slots_by_weekday || []];
      

      let response = null;
      // SE GIORNO NON ESISTE IN WEEK WORKINH HOUR E ASSOCIO UN TURNO GIORNALIERO ESISTENTE -> CREAZIONE GIORNO IN WWH E ASSOCIAZIONE CON WH
      if (!dayExists) {
        const data = {
          week_day: selectedDayValue,
          weekly_working_hour: weekWorkingHourId,
          time_slots: [],
          working_hour: null,
        }

        if (selectedWorkingHourId) {
          data.working_hour = selectedWorkingHourId;
        } else {
        // SE GIORNO NON ESISTE IN WEEK WORKINH HOUR E ASSOCIO UN TIME SLOT -> CREAZIONE GIORNO IN WWH E NUOTO TIMESLOT
          data.time_slots = [
              {
                start_at: newStartTime,
                end_at: newEndTime,
                breaks: breaks,
              },
            ];
        }      
        
        response = await addWeeklyWorkingHourSlot(token, data);
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Salvato!",
          showConfirmButton: false,
          timer: 1500
        });
      }
      else {

        // IL GIORNO QUA, ESISTE!
        const data = {};
        
        // OH NO c'è UN SWHID!
        if (selectedWorkingHourId) {
          data.working_hour = selectedWorkingHourId;
        }
        else if(newStartTime && newEndTime) {
          data.time_slots = [{
              start_at: newStartTime,
              end_at: newEndTime,
              breaks: breaks,
          }];
        }
        
        response = await patchUpdateWeeklyWorkingHourSlot(token, selectedWeekWorkingHourSlot.id, data);
        
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Salvato!",
          showConfirmButton: false,
          timer: 1500
        });
      }

      if(!response) {
        Swal.fire({
          icon: "error",
          title: "Errore nel salvataggio della richiesta",
        });
      }

      if (onWeekWorkingHour && response) {
        const {id, time_slots, week_day, working_hour} = response;
        const workingHourData = workingHours.find(wh => wh.id === working_hour);
        onWeekWorkingHour(
          {id, time_slots, week_day, working_hour: workingHourData},
          weekWorkingHourId
        );
      }
    

      setWorkStartTime('');
      setWorkEndTime('');
      setPauseTimes([]);
      setCreatingPause(false);
  
      handleCancelClick();
 
    } catch (error) {
      console.error('Errore durante la creazione del time slot:', error);
  
      let errorMessage = 'Errore durante la creazione della fascia oraria. Per favore riprova.';

      if (!error.response) {
        errorMessage = 'Errore, riprova più tardi.';
      } else if (error.response && error.response.data) {
        const errorData = error.response.data;
        const errorMessages = [];

        const extractMessages = (obj) => {
          if (Array.isArray(obj)) {
            obj.forEach(item => extractMessages(item));
          } else if (typeof obj === 'object' && obj !== null) {
            Object.values(obj).forEach(value => extractMessages(value));
          } else if (typeof obj === 'string') {
            errorMessages.push(obj);
          }
        };

        extractMessages(errorData);

        if (errorMessages.length > 0) {
          errorMessage = errorMessages.join(' ');
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
    }
  };
  

  const handleToggleChange = async (selectedOption) => {
    setSelectedOption(selectedOption);
    setSelectedWorkingHourId(null);
    setWorkStartTime('');
    setWorkEndTime('');
    setPauseTimes([]);
    setCreatingPause(false);

    if (selectedOption === "ASSEGNA TURNO GIORNALIERO") {
      try {
        const workingHours = await getWorkingHoursCompound(token, selectedOuId);
        setWorkingHours(workingHours);
      } catch (error) {
        console.error('Errore durante il recupero dei turni', error);
      }
    }
  };

  useEffect(() => {
    const fetchWorkingHours = async () => {
      if (selectedOption !== "ASSEGNA TURNO GIORNALIERO") return;

      try {
        const workingHours = await getWorkingHoursCompound(token, selectedOuId);
        setWorkingHours(workingHours);
      } catch (error) {
        console.error('Errore durante il recupero dei turni', error);
      }
    };

    fetchWorkingHours();
  }, [token, selectedOption, selectedOuId]);

  const handleSelectWorkingHour = (selected) => {    
    if (!selected) {
      return;
    }
    setSelectedWorkingHourId(selected.id);    
  };

  return (
    <>
      {(
        <div className='border border-solid-2 border-gray-200 shadow-md rounded-md my-5 bg-white w-full'>
          <div className='grid grid-cols-1 md:mx-4 mx-0 mt-4'>
            <div className='flex justify-between'>
              <label htmlFor="parent" className="text-sm font-medium text-gray-700 m-0 col-span-1 flex items-center ps-2">Giorno selezionato: <span className='text-indigo-800 font-semibold pl-1'>{(selectedDay).toUpperCase()}</span></label>
              <button onClick={handleCancelClick} className="border shadow text-gray-700 text-sm w-24 px-2 py-1 rounded-md hover:bg-gray-200 focus:outline-none font-semibold"
              >
                Chiudi
              </button>
            </div>
          </div>
          
          {selectedDay && (
            <div className='justify-center flex pt-4 pb-4'>
              <Toggle
                color="indigo"
                gradeBgColor="600"
                optionLeft="ASSEGNA TURNO GIORNALIERO"
                optionRight="AGGIUNGI FASCIA ORARIA"
                selectedOption={selectedOption}
                onChange={handleToggleChange}
              />
            </div>
          )}

     
          {selectedDay && selectedOption === "AGGIUNGI FASCIA ORARIA" && (
            <>
              <div className='grid grid-cols-1 mx-0 md:mx-4 mt-0'>
                {error && (
                  <div className="grid grid-cols-1 mx-4">
                    <p className="text-red-500 text-sm text-center">{error}</p>
                  </div>
                )}
                {selectedWeekWorkingHourSlot && (
                  <div className="flex justify-center mt-8">
                    <table className="w-full table-fixed border border-gray-200 rounded-lg shadow text-sm">
                      <thead className="bg-indigo-50 text-center">
                        <tr>
                          <th className="px-4 py-2 text-gray-600 w-1/2">
                            <BriefcaseIcon className="w-4 h-4 text-indigo-700 me-1 inline-block" /> Fascia Oraria
                          </th>
                          <th className="px-4 py-2 text-gray-600 w-1/2">
                            <LocalBarIcon style={{ height: '15px', width: '15px', color: '#4f46e5', marginRight: '4px' }} /> Pausa
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedWeekWorkingHourSlot.time_slots
                          .sort((a, b) => a.start_at.localeCompare(b.start_at))
                          .map((slot) => (
                            <tr key={slot.id}>
                              <td className="border px-4 py-2 w-1/2 font-medium">
                                {slot.start_at} - {slot.end_at}
                              </td>
                              <td className="border px-4 py-2 w-1/2">
                                {slot.breaks.length > 0 ? (
                                  <div className="space-y-1">
                                    {slot.breaks.map((br) => (
                                      <div key={br.id} className="flex items-center justify-center space-x-1 text-gray-600">
                                        <span>{br.start_at} - {br.end_at}</span>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <span className="text-gray-400">Nessuna</span>
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className='border border-gray-200 shadow-md rounded-md my-5 bg-white px-4 pb-4'>
                  <div className='grid md:grid-cols-6 sm:grid-cols-1 mt-4 justify-between'>
                    <div className='md:col-span-2 col-span-1'>
                      <div className="mb-3 flex items-center">
                        <label htmlFor="start-time" className="sm:w-40 text-sm font-medium text-gray-700 flex items-center space-x-1 me-4 sm:me-0 pl-2 sm:pl-0">
                          <BriefcaseIcon className='h-5 w-5 mr-0.5' />
                          Dalle ore:
                        </label>
                        <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                          <input 
                            type="text"
                            placeholder='hh:mm' 
                            value={workStartTime} 
                            onInput={handleWorkStartTimeChange}
                            onBlur={() => handleWorkTimeBlur('start')}
                            className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block sm:w-40 w-28 shadow-md sm:text-sm required" 
                            style={{ paddingRight: '2.5rem' }}
                          />
                          <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                            <ClockIcon className='w-4 h-4' />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className='col-span-2 sm:col-span-1'></div>
                    <div className='md:col-span-2 sm:col-span-1 flex items-center'>
                      <label htmlFor="start-time" className="sm:w-40 text-sm font-medium text-gray-700 flex items-center space-x-1 me-6 sm:me-0 pl-2 sm:pl-0">
                        <BriefcaseIcon className='h-5 w-5 mr-0.5' />
                        Alle ore:
                      </label>
                      <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                        <input 
                          type="text"
                          placeholder='hh:mm' 
                          value={workEndTime} 
                          onInput={handleWorkEndTimeChange} 
                          onBlur={() => handleWorkTimeBlur('end')}
                          className="p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block sm:w-40 w-28 shadow-md sm:text-sm required" 
                        />
                        <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                          <ClockIcon className='w-4 h-4' />
                        </span>
                      </div>
                    </div>
                  </div>
            

                  {workTimeError && (
                    <p className="text-red-500 text-sm justify-center flex pt-8 ">{workTimeError}</p>
                  )}

                  <div className='grid md:grid-cols-6 sm:grid-cols-1 pt-3 pb-2 items-center'>
                    <div className='col-span-6 flex items-center'>
                      <label htmlFor="parent" className="block text-sm font-medium text-gray-700 m-0 col-span-1">Inserisci Fascia Oraria della Pausa</label>
                      {!creatingPause && !pauseTimes.some(pause => !pause.confirmed) ? (
                        <button onClick={handleAddPause} className="ml-3 border rounded-md bg-white py-1 px-2 mr-2 text-center text-sm font-semibold text-gray-700 shadow-md hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 flex items-center">
                          <PlusIcon className='w-5 h-5 text-indigo-500 mr-1' />  
                          AGGIUNGI PAUSA
                        </button>
                      ) : (
                        <button onClick={() => { setCreatingPause(false); setPauseTimes(pauseTimes.filter(pause => pause.confirmed)) }} className="ml-3 border rounded-md bg-white py-1 px-2 mr-2 text-center text-sm font-semibold text-gray-700 shadow-md hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 flex items-center">
                          ANNULLA
                        </button>
                      )}
                    </div>
                  </div>

                  {pauseTimes.map((pause, index) => (
                    <div key={index} className="grid md:grid-cols-6 sm:grid-cols-1 mt-4 justify-between">
                      {!pause.confirmed ? (
                        <>
                          <div className="md:col-span-2 col-span-6 flex items-center">
                            <label htmlFor="start-time" className="sm:w-40 text-sm font-medium text-gray-700 flex items-center space-x-1 me-5 sm:me-0">
                              <SvgBreak />
                              Dalle ore:
                            </label>
                            <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                              <input 
                                type="text"
                                placeholder='hh:mm' 
                                value={pause.start_at} 
                                onInput={(e) => handlePauseStartTimeChange(index, e)}
                                onBlur={() => handlePauseTimeBlur(index, 'start_at')} 
                                className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block sm:w-40 w-28 shadow-md sm:text-sm" 
                                disabled={!workStartTime || !workEndTime || pause.confirmed} 
                              />
                              <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                                <ClockIcon className='w-4 h-4' />
                              </span>
                            </div>
                          </div>
                          <div className="col-span-2 sm:col-span-1"></div>
                          <div className="md:col-span-2 col-span-6 flex items-center">
                            <label htmlFor="start-time" className="sm:w-40 w-28 text-sm font-medium text-gray-700 flex items-center space-x-1 sm:me-0">
                              <SvgBreak />
                              Alle ore:
                            </label>
                            <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                              <input 
                                type="text" 
                                placeholder='hh:mm'
                                value={pause.end_at} 
                                onInput={(e) => handlePauseEndTimeChange(index, e)} 
                                onBlur={() => handlePauseTimeBlur(index, 'end_at')} 
                                className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block sm:w-40 w-28 shadow-md sm:text-sm" 
                                disabled={!workStartTime || !workEndTime || pause.confirmed} 
                              />
                              <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                                <ClockIcon className='w-4 h-4' />
                              </span>
                            </div>
                          </div>
                          <div className='sm:col-span-1 col-span-2 justify-center items-center ml-2 sm:flex'>
                            <button
                                onClick={() => handleConfirmPause(index)}
                                className="bg-indigo-600 text-white text-sm px-2 py-1 font-bold rounded-md hover:bg-indigo-500 focus:outline-none focus:bg-indigo-600 items-center justify-center"
                            >
                                AGGIUNGI
                            </button>
                          </div>
                          <div className='col-span-3 justify-center mt-4 flex sm:hidden'>
                            <button
                              onClick={() => handleConfirmPause(index)}
                              className="bg-indigo-600 text-white text-sm p-2 rounded-md hover:bg-indigo-500 focus:outline-none focus:bg-indigo-500 items-center justify-center md:hidden block"
                            >
                            Conferma
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="md:col-span-2 col-span-1 flex items-center">
                            <label htmlFor="start-time" className="sm:w-40 text-sm font-medium text-gray-700 flex items-center space-x-1 me-4 sm:me-0">
                              <SvgBreak />
                              Dalle ore:
                            </label>
                            <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                              <input 
                                type="time" 
                                value={pause.start_at} 
                                className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block sm:w-40 w-28 shadow-md sm:text-sm" 
                                disabled 
                              />
                              <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                                <ClockIcon className='w-4 h-4' />
                              </span>
                            </div>
                          </div>
                          <div className="col-span-1"></div>
                          <div className="md:col-span-2 col-span-1 flex items-center">
                            <label htmlFor="start-time" className="sm:w-40 text-sm font-medium text-gray-700 flex items-center space-x-1 me-6 sm:me-0">
                              <SvgBreak />
                              Alle ore:
                            </label>
                            <div style={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
                              <input 
                                type="time" 
                                value={pause.end_at} 
                                className="mt-1 p-1 pl-4 border-gray-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 block sm:w-40 w-28 shadow-md sm:text-sm" 
                                disabled 
                              />
                              <span style={{ position: 'absolute', top: '50%', right: '8px', transform: 'translateY(-50%)' }}>
                                <ClockIcon className='w-4 h-4' />
                              </span>
                            </div>
                          </div>
                          <div className='col-span-1 items-center ml-2 sm:block hidden'>
                            <button onClick={() => handleDeletePause(index)} className="bg-white text-gray-900 text-sm p-2 rounded-md hover:text-red-600 focus:outline-none focus:text-gray-900 h-8 flex items-center text-left">
                              <TrashIcon className="h-5 w-5 mr-2" />
                            </button>
                          </div>
                          <div className='col-span-2 mt-4 ml-2 block sm:hidden border rounded-md justify-end'>
                            <button onClick={() => handleDeletePause(index)} className="bg-white text-gray-900 text-sm p-2 w-full flex justify-center rounded-md hover:text-red-600 focus:outline-none focus:text-gray-900 h-8 items-center text-center">
                              <TrashIcon className="h-5 w-5 mr-2" />
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                    
                  ))}

                  <button 
                    className='text-xs bg-indigo-600 hover:bg-indigo-500 rounded-md p-2 text-white font-bold mt-4'
                    onClick={handleSaveTimeSlot}
                  >
                    CONFERMA
                  </button>
                </div>
              </div>
            </>
          )}

          {selectedDay && selectedOption === "ASSEGNA TURNO GIORNALIERO" && (
            <div className='grid grid-cols-6 px-5 mb-4 w-full'>
              <div className='col-span-1 flex '>
                <h3 className='block text-sm font-medium text-gray-700 pt-2 me-3'>Seleziona</h3>
              </div>
              <div className='col-span-5 mb-4 border border-gray-200 rounded-md'>
                <ComboboxAutocomplete
                  options={workingHours}
                  bgActiveColor="bg-indigo-50"
                  textActiveColor="text-gray-900"
                  placeholder='Assegna turno giornaliero'
                  onChange={handleSelectWorkingHour}
                  value={workingHours.find(wh => wh.id === selectedWorkingHourId)}
                  positionOptions='relative'
                />
              </div>
              <div className='col-span-6'>
                {selectedWorkingHour && (
                    <TabellaTurnoGiornaliero selectedWorkingHour={selectedWorkingHour} />
                )}
              </div>
            </div>
          )}
          {selectedWorkingHourId && (
            <button onClick={handleSaveTimeSlot} className="bg-indigo-600 text-white text-sm px-4 py-2 mb-4 rounded-md hover:bg-indigo-500 focus:outline-none focus:bg-indigo-600 w-32 font-semibold"
            >
              Salva
            </button>
          )}
        </div>
      )}
    </>
  );
}

export default AddNewWeekTimeSlot;

